export enum ProductVideoVariant {
  NO_VIDEO = "noVideo",
  ONE_MAIN_VIDEO = "oneMainVideo",
  FOR_EACH_VIDEO = "forEachVideo"
}

export enum ProductBothTogetherMethod {
  NO_PRODUCTS = "noProducts",
  ONE_SET_FOR_ALL_VARIANTS = "oneSetForAllVariants",
  PRODUCTS_FOR_EACH_VARIANT = "productsForEachVariant"
}

export enum ApiRoutesProducts {
  Product = "admin/products",
  ProductVariant = "admin/products/variants",
  ProductVariantSKUAndShortId = "admin/products/generate-sku-and-short-id-with-reservation",
  AllProducts = "admin/products/all",
  OneProduct = "admin/products/one",
  ProductFilterMeta = "admin/products/all-filters-meta",
  ProductBoxes = "inventory-box-admin/available-in-boxes",
  ProductComments = "admin/products/reviews",
  MerchantPrice = "flex-data/merchant-price",
  ProductVariantVisibility = "visibility",
  ProductBadges = "admin/products/variants/badges",
  CheckBarcodeAvailability = "admin/products/barcodes/check-availability",
  LifetimeStats = "admin/products/lifetime-stats"
}

export enum EProductVariantVisibility {
  Visible = "Visible",
  PackOnly = "PackOnly",
  Hidden = "Hidden"
}

export enum ProductBadgeCategory {
  Deals = "Deals",
  Event = "Event",
  Buzz = "Buzz",
  Style = "Style",
  Craft = "Craft",
  Tech = "Tech",
  Soon = "Soon",
  Jewelry = "Jewelry",
  JewelryStyle = "JewelryStyle",
  Health = "Health"
}

export enum ProductBadgeLabel {
  LowPrice = "Low Price",
  FlashDeal = "Flash Deal",
  SpecialOffer = "Special Offer",
  LimitedTimeSale = "Limited-Time Sale",
  LowStock = "Low Stock",
  ExclusiveDiscount = "Exclusive Discount",
  BestPriceGuaranteed = "Best Price Guaranteed",
  PerfectGift = "Perfect Gift",
  ExclusiveLaunch = "Exclusive Launch",
  RamadanSpecial = "Ramadan Special",
  TabaskiSpecial = "Tabaski Special",
  ChristmasEdition = "Christmas Edition",
  Trending = "Trending",
  ProPick = "Pro Pick",
  RomanticVibes = "Romantic Vibes",
  ForKids = "For Kids",
  StyleOfTheDay = "Style of the Day",
  ModestStylish = "Modest & Stylish",
  Handmade = "Handmade",
  LimitedEdition = "Limited Edition",
  LongBatteryLife = "Long Battery Life",
  UniversalCompatibility = "Universal Compatibility",
  WaterResistant = "Water Resistant",
  AssinieVibes = "Assinie Vibes",
  WorkingGirl = "Working Girl",
  ChicClassy = "Chic & Classy",
  StainlessSteel = "Stainless Steel",
  GoldPlated = "Gold Plated",
  FashionJewelry = "Fashion jewelry",
  Silver = "Silver",
  Health = "Health"
}
